module.exports = __webpack_public_path__ + "img/reveal-deal-unlock-red-gif-01.d559bd52.gif";